
import { Injectable } from '@angular/core';
import { Coordenada } from 'src/app/models/entities/coordenada';
import { MapsAPILoader, LatLngBounds, LatLng } from '@agm/core';
import { } from 'googlemaps';
import { GooglePolyline } from 'src/app/models/google-polyline';
import { GooglePolylinePoint } from 'src/app/models/google-polyline-point';
import { Segmento } from 'src/app/models/entities/segmento';

declare const google: any;

@Injectable({
    providedIn: 'root'
})
export class MapUtils {

    public readonly ZOOM_PAIS_MEXICO: number = 5;
    public readonly LATITUD_PAIS_MEXICO: number = 23.60260144610932;
    public readonly LONGITUD_PAIS_MEXICO: number = -101.69143943935545;

    public constructor(private mapsAPILoader: MapsAPILoader) { }



    public obtenerCoordenadaCentralArregloPolylines(coordenadasElemento: Array<Coordenada[]>): Coordenada {
        let posicionCentralPolylines: number = Math.floor(coordenadasElemento.length / 2);
        let posicionCentralPolyline: number = Math.floor(coordenadasElemento[posicionCentralPolylines].length / 2);
        return (coordenadasElemento[posicionCentralPolylines])[posicionCentralPolyline];
    }

    public obtenerCoordenadaInicialArregloPolylines(coordenadasElemento: Array<Coordenada[]>): Coordenada {
        return (coordenadasElemento[0])[0];
    }

    public obtenerCoordenadaFinalArregloPolylines(coordenadasElemento: Array<Coordenada[]>): Coordenada {
        let ultimaPolyline: Coordenada[] = coordenadasElemento[coordenadasElemento.length - 1];
        let ultimaCoordenada: Coordenada = ultimaPolyline[ultimaPolyline.length - 1];
        return ultimaCoordenada;
    }



    public calcularDistanciaEntreDosCoordenadas(c1: Coordenada, c2: Coordenada): Promise<string> {
        return new Promise((resolve, reject) => {
            this.mapsAPILoader.load().then(() => {
                const p1 = new google.maps.LatLng(
                    c1.latitud,
                    c1.longitud
                );
                const p2 = new google.maps.LatLng(
                    c2.latitud,
                    c2.longitud
                );
                resolve((
                    google.maps.geometry.spherical.computeDistanceBetween(p1, p2)
                ).toFixed(2));
            });
        });
    }

    public calcularDistanciaDePolyline(polyline: GooglePolyline): Promise<string> {
        return new Promise((resolve, reject) => {
            this.mapsAPILoader.load().then(() => {
                let distancia: number = 0;
                for (let indice = 0; indice < polyline.googlePolylinePoints.length - 1; indice++) {
                    const p1 = new google.maps.LatLng(
                        polyline.googlePolylinePoints[indice].lat,
                        polyline.googlePolylinePoints[indice].lng
                    );
                    const p2 = new google.maps.LatLng(
                        polyline.googlePolylinePoints[indice + 1].lat,
                        polyline.googlePolylinePoints[indice + 1].lng
                    );
                    distancia += google.maps.geometry.spherical.computeDistanceBetween(p1, p2)
                }
                resolve(distancia.toFixed(2));
            });
        });
    }

    public async calcularDistanciaPath(path: Array<google.maps.LatLng>): Promise<string> {
        await this.mapsAPILoader.load();
        return (google.maps.geometry.spherical.computeLength(path) / 1000).toFixed(2);
    }

    public async obtenerLongitudSegmento(coordenadas: Coordenada[]): Promise<number> {
        await this.mapsAPILoader.load();
        let path: Array<google.maps.LatLng> = Array.from(coordenadas, (c: Coordenada) => new google.maps.LatLng(c.latitud, c.longitud));
        let longitudSegmento: number = google.maps.geometry.spherical.computeLength(path);
        return parseFloat(longitudSegmento.toFixed(2));
    }

    public async obtenerLongitudArreglosCoordenadas(arregloCoordenadas: Coordenada[][]): Promise<number> {
        await this.mapsAPILoader.load();
        let longitudSegmentos: number = 0;
        arregloCoordenadas.forEach((coordenadas: Coordenada[]) => {
            let path: Array<google.maps.LatLng> = Array.from(coordenadas, (c: Coordenada) => new google.maps.LatLng(c.latitud, c.longitud));
            let longitudSegmento: number = google.maps.geometry.spherical.computeLength(path);
            longitudSegmentos += parseFloat(longitudSegmento.toFixed(2));
        });
        return longitudSegmentos;
    }

    public async obtenerLongitudArregloSegmentos(segmentos: Segmento[]): Promise<number> {
        await this.mapsAPILoader.load();
        let longitudSegmentos: number = 0;
        segmentos.forEach((segmento: Segmento) => {
            let path: Array<google.maps.LatLng> = Array.from(segmento.coordenadas, (c: Coordenada) => new google.maps.LatLng(c.latitud, c.longitud));
            let longitudSegmento: number = google.maps.geometry.spherical.computeLength(path);
            longitudSegmentos += parseFloat(longitudSegmento.toFixed(2));
        });
        return longitudSegmentos;
    }

    /**
     * 
     * @param map 
     * @param polyline 
     */
    public calcularDistanciaDePolylinePorColor(polyline: any[], capa: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.mapsAPILoader.load().then(() => {
                let distanciaVerde: number = 0;
                let distanciaRojo: number = 0;
                let distanciaAmarillo: number = 0;
                for (let index = 0; index < polyline.length; index++) {
                    for (let indice = 0; indice < polyline[index].points.length - 1; indice++) {
                        const p1 = new google.maps.LatLng(
                            polyline[index].points[indice].lat,
                            polyline[index].points[indice].lng
                        );
                        const p2 = new google.maps.LatLng(
                            polyline[index].points[indice + 1].lat,
                            polyline[index].points[indice + 1].lng
                        );
                        if (polyline[index].color == '#04c346') {
                            distanciaVerde += google.maps.geometry.spherical.computeDistanceBetween(p1, p2);
                        }
                        if (polyline[index].color == '#ff0000') {
                            distanciaRojo += google.maps.geometry.spherical.computeDistanceBetween(p1, p2);
                        }
                        if (polyline[index].color == '#ffff00') {
                            distanciaAmarillo += google.maps.geometry.spherical.computeDistanceBetween(p1, p2);
                        }
                    }
                }
                resolve(
                    {
                        distanciaVerde: distanciaVerde,
                        distanciaRojo: distanciaRojo,
                        distanciaAmarillo: distanciaAmarillo,
                        capa: capa
                    }
                );
            });
        });
    }

    /**
     * Centra una polyline
     * @param map 
     * @param polyline 
     */
    public async centrarPolyline(map: any, polyline: GooglePolyline) {
        await this.mapsAPILoader.load();
        const bounds: LatLngBounds = new google.maps.LatLngBounds();
        for (const point of polyline.googlePolylinePoints) {
            bounds.extend(new google.maps.LatLng(point.lat, point.lng));
        }
        map.fitBounds(bounds);
    }
    /**
     * Centra un marker
     * @param map 
     * @param point 
     */
    public async centrarMarker(map: any, lat: number, lng: number) {
        await this.mapsAPILoader.load();
        const bounds: LatLngBounds = new google.maps.LatLngBounds();
        bounds.extend(new google.maps.LatLng(lat, lng));
        map.fitBounds(bounds);
    }

    /**
    * Centra un arreglo de polylines
    * @param map 
    * @param point 
    */
    public async centrarArregloDePolylines(map: any, polylines: GooglePolyline[]) {
        let polyline: GooglePolyline = {
            googlePolylinePoints: polylines.reduce((a, b) => [...a, ...b.googlePolylinePoints], [])
        };
        this.centrarPolyline(map, polyline);
    }

    public desfasarPolyline(polyline: GooglePolyline, desfase: number, stroke?: number): GooglePolyline {

        let polylinePointDesfasado: GooglePolylinePoint[] = polyline.googlePolylinePoints.map((p: GooglePolylinePoint) => ({
            lat: p.lat + desfase,
            lng: p.lng
        }));
        polyline.googlePolylinePoints = polylinePointDesfasado;
        if (stroke) {
            polyline.stroke = stroke;
        }

        return polyline;
    }

}
